import { gql } from '@apollo/client';

export const postTarjetasCreditoSP = gql`
mutation TarjetasCreditoSPApiRQ{
    TarjetasCreditoSPApiRQ(input: $input)  
        @rest(type: "TarjetasCreditoSPApiRS", path: "/api/gateway/formularios/Tarjetas", method: "POST"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
`